import Box from "@mui/material/Box";
import { FlexColumn, PaneHeader } from "designSystem/index";
import DojoView from "csi/page/DojoView";
import { useStore } from "csi/state/hooks";
import { observer } from "mobx-react-lite";
import React from "react";
import TaskRightPaneComponent from "../state/TaskRightPaneComponent";

export const ProcessDefinitionTask = observer(() => {
	const { rightPaneStore } = useStore();
	const { cache, editViewDef, taskUrl } = rightPaneStore.adHocComponent as TaskRightPaneComponent;
	const viewParams = {
		bFocused: true,
		cacheView: cache,
		defView: editViewDef,
	};

	return (
		<FlexColumn>
			<PaneHeader titleRes="CamundaTaskSetup" />
			<Box flexGrow={1} overflow="hidden">
				<DojoView
					fullHeight
					nodeUrl={taskUrl}
					viewId={editViewDef?.m_id || "Properties"}
					viewParams={viewParams}
				/>
			</Box>
		</FlexColumn>
	);
});

export default ProcessDefinitionTask;
